import { bannerControllerGetBanner } from "@/shared/api/generated";
import { useQuery } from "@tanstack/react-query";

export function useGetBanner() {
  return useQuery({
    queryFn: bannerControllerGetBanner,
    queryKey: ["BANNER"],
    staleTime: 60_000,
    refetchOnMount: "always",
  });
}
